var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AutobuyerBox',{attrs:{"autobuyer":_vm.autobuyer,"name":"T0 Auto Researcher","extraInfos":_vm.extraInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }